<template>
  <div class='service-provider-worker-profile'>
    <avatar-upload class="avatar" :file-url="fileUrl"  @changed='updateAvatarUrl'/>
    <div class='form'>
      <edit-service-provider-worker-profile-form class='profile-form'/>
      <div class="actions d-flex">
        <v-btn color="primary" class='submit-form' @click="submit">
          {{ $t('save') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EditServiceProviderWorkerProfileForm from '@/components/forms/EditServiceProviderWorkerProfileForm.vue';
import AvatarUpload from '@/components/common/AvatarUpload.vue';
import {
  UPDATE_SERVICE_PROVIDER_WORKER_PROFILE,
} from '@/store/user/actionTypes';

export default {
  name: 'ServiceProviderWorkerProfile',
  components: {
    EditServiceProviderWorkerProfileForm,
    AvatarUpload,
  },
  computed: {
    ...mapGetters([
      'serviceProviderWorkerProfileDetails',
    ]),
    fileUrl() {
      if (!this.serviceProviderWorkerProfileDetails?.avatarURL || this.serviceProviderWorkerProfileDetails?.avatarURL?.startsWith('data')) {
        return this.serviceProviderWorkerProfileDetails?.avatarURL;
      }
      return `${this.serviceProviderWorkerProfileDetails?.avatarURL}?${Date.now().toString()}` || null;
    },
  },
  methods: {
    updateAvatarUrl(file) {
      this.serviceProviderWorkerProfileDetails.avatarURL = file;
    },
    async submit() {
      await this.$store.dispatch(UPDATE_SERVICE_PROVIDER_WORKER_PROFILE, this.serviceProviderWorkerProfileDetails);
    },
  },
};
</script>

<style lang='scss'>
@import '../../assets/styles/variables';
.service-provider-worker-profile {
  display: flex;
  flex: 1;

  padding-top: 40px;
  padding-bottom: 40px;
  margin-left: 10%;

  padding-right: 152px;

  border-radius: 4px;
  background-color: $default-background-color;
}

.form {
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 500px;
  .profile-form {
    flex: 1;
    max-width: 63%;
  }
}

.avatar {
  flex: 0.35;
  margin-right: 7%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
